import ModalAdvertisement from "@/vue/components/ModalAdvertisement";
import {deepCopy} from "tupy-helperjs";
export const baseAdvertisement = {
    id: null,
    title: null,
    subtitle: null,
    phone: null,
    photo: null,
    company_name: null,
    company_ami: null,
    name_user: null,
    check: true,
}

new Vue({
    el: '#modal-advertisement-vue',
    name: 'ModalAdvertisementManager',
    data(){
        return {
            advertisement: deepCopy({...baseAdvertisement})
        }
    },
    components: {
        ModalAdvertisement
    },
    mounted() {
        this.observableModal()
    },
    methods: {
        observableModal(){
            let myModalEl = document.getElementById('advertisementContact');
            myModalEl.addEventListener('show.bs.modal', (event) => {
                this.advertisement = JSON.parse(event.relatedTarget.getAttribute('data-advertisement'))
            })

            myModalEl.addEventListener('hide.bs.modal', () => {
                this.advertisement = deepCopy({...baseAdvertisement})
            })
        }
    }
})
